import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { withTranslation } from '../src/i18n';
import Home from '../containers/Home';
import {
  getHomePerformancesAction,
  getHomeNumbersAction,
  getHomeArtistsAction,
  getHomeHighlightsAction,
} from '../containers/Home/actions';
import { dateFormats, PERFORMANCE_TYPES_ID } from '../constants/consts';
import { getList } from '../containers/App/actions';
import { PRODUCTIONS } from '../constants/endpointConstants';
import getInjectors from '../store/reducerInjectors';
import reducer, { key } from '../containers/Home/reducer';
import { useInjectReducer } from '../store/injectReducer';
import { createDate } from '../utils/date';
import { fetchAppConstants } from '../utils/queries/productionsQuery';
import { futureDateUpTo1Years, pastDateUpTo3Years } from '../utils/common';

const IndexPage = ({ t }) => {
  useInjectReducer([{ key, reducer }]);

  const [performanceDateRange, setPerformanceDateRange] = React.useState({
    performanceStartDate: pastDateUpTo3Years,
    performanceEndDate: futureDateUpTo1Years,
  });

  React.useEffect(() => {
    fetchAppConstants().then(response => {
      const constantsData = response?.data?.data[0];
      const { PERFORMANCE_START_DATE: performanceStartDate, PERFORMANCE_END_DATE: performanceEndDate } = constantsData;
      if (performanceStartDate && performanceEndDate) {
        setPerformanceDateRange({
          performanceStartDate: createDate(performanceStartDate).toDate(),
          performanceEndDate: createDate(performanceEndDate).toDate(),
        });
      }
    });
  }, []);

  return <Home t={t} performanceDateRange={performanceDateRange} />;
};

IndexPage.propTypes = {
  t: PropTypes.func,
};

IndexPage.getInitialProps = async ctx => {
  const { store } = ctx;
  getInjectors(store).injectReducer([{ key, reducer }]);
  const dayFrom = createDate().format(dateFormats.basic);

  const strippedQuery = {};
  if (!strippedQuery.performance_type_id) {
    strippedQuery.performance_type_id = [PERFORMANCE_TYPES_ID.WORLD_PREMIERE, PERFORMANCE_TYPES_ID.NATIONAL_PREMIERE];
  }

  const artists = get(store.getState().Home, 'artists.data', []);
  const performances = get(store.getState().Home, 'performances.data', []);
  const highlights = get(store.getState().Home, 'highlights.data', []);

  if (artists.length === 0) {
    store.dispatch(getHomeArtistsAction());
  }
  store.dispatch(getHomeNumbersAction());
  if (performances.length === 0) {
    store.dispatch(getHomePerformancesAction());
  }
  if (highlights.length === 0) {
    store.dispatch(
      getList({
        endpoint: PRODUCTIONS,
        sagaRoutine: getHomeHighlightsAction,
        params: {
          queryParams: {
            ...strippedQuery,
            date_from: dayFrom,
            sort: 'year',
            added_by: 'admin,company',
            approved_by: 'admin,company',
          },
        },
      }),
    );
  }

  return { namespacesRequired: ['translation'] };
};

export default withTranslation('translation')(IndexPage);
